import * as React from "react";
import styled from "styled-components";

import Translate from "../../common/components/Translate";
import Icon from "../../common/components/Icon";
import PostCard, { PostCardSimpleModels } from "./PostCardSimple";

type Post = PostCardSimpleModels["Post"];

export interface FeaturedPostsSectionModels {
  Post: Post;
}
interface Props {
  post: Post;
  pinned: boolean;
  editable?: boolean;
}

const FeaturedPostCard: React.SFC<Props> = props => {
  const { post, pinned, editable } = props;

  return (
    <div>
      <PostCard post={post} />
      {editable && (
        <Status>
          {pinned ? <PinIcon name="wt-icon-pin" /> : <StyledIcon name="wt-icon-newspaper" />}
          <Translate id={pinned ? "company.posts.featured_post_pinned" : "company.posts.featured_post_latest"} />
        </Status>
      )}
    </div>
  );
};

const Status = styled.div`
  margin-top: 9px;
  padding-bottom: 3px;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.27);
`;

const StyledIcon = styled(Icon)`
  margin-right: 5px;
  font-size: 14px;
`;

const PinIcon = StyledIcon.extend`
  margin-top: -3px;
`;

export default FeaturedPostCard;



// WEBPACK FOOTER //
// ./frontend/src/posts/components/FeaturedPostCard.tsx